(() => {
  const loading = 'pagination__load-more--loading';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-blog-section] .pagination__load-more');
    if (!button || button.classList.contains(loading)) return;

    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return;
    event.preventDefault();

    const container = button.closest('[data-blog-section]');
    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', container.dataset.blogSection);

    button.classList.add(loading);
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');

      const list = container.querySelector('.blog-page__articles');
      const newItems = html.querySelectorAll('.blog-page__articles > .blog-page__item');
      const firstNew = newItems[0];
      list.append(...newItems);

      const pagination = container.querySelector('.pagination__container');
      const newPagination = html.querySelector('.pagination__container');
      if (pagination && newPagination) pagination.replaceWith(newPagination);

      firstNew?.querySelector('.blog-page__item-title a')?.focus({ preventScroll: true });
    } catch (error) {
      window.location.href = nextUrl;
    } finally {
      button.classList.remove(loading);
      button.removeAttribute('aria-busy');
    }
  });
})();
